import { createFeature, createReducer, createSelector, on } from "@ngrx/store";
import { LovsStoreInterface } from "src/app/shared/interfaces/settings/lovs";
import { lovsActions } from "./lovs.action";

const initailState: LovsStoreInterface = {
    data: {},
    loadingState: {},
};

const lovsFeature = createFeature({
    name: "lovs",
    reducer: createReducer(
        initailState,
        on(lovsActions.setLovData, (state, action) => ({
            ...state,
            data: {
                ...state.data,
                [action.key]: action.data?.admissions || action.data,
            },
        })),
        on(lovsActions.removeLovData, (state, action) => ({
            ...state,
            data: {
                ...state.data,
                [action.key]: undefined,
            },
        })),
        on(lovsActions.toggleLoadingState, (state, action) => ({
            ...state,
            loadingState: {
                ...state.loadingState,
                [action.key]: !state.loadingState[action.key],
            },
        })),
    ),
});

export const {
    name: lovsFeatureKey,
    reducer: lovsReducer,
    selectData,
    selectLoadingState: selectLoadingStateData,
} = lovsFeature;

export const selectLovData = (props: { url: string }) =>
    createSelector(selectData, (data: Record<string, any>) => {
        return data[props.url];
    });

export const selectLoadingState = (props: { url: string }) =>
    createSelector(selectLoadingStateData, (loadingState: Record<string, boolean>) => {
        return loadingState[props.url];
    });
